// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from 'firebase/app';

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
// import 'firebase/analytics;

// Add the Firebase products that you want to use
import 'firebase/messaging';
import 'firebase/analytics';

const config = {
  apiKey: window.FIREBASE_API_KEY,
  authDomain: window.FIREBASE_AUTH_DOMAIN,
  projectId: window.FIREBASE_PROJECT_ID,
  appId: window.FIREBASE_APP_ID,
  messagingSenderId: window.FIREBASE_MESSAGING_SENDER_ID
};

const shouldDisableFirebase = window.FORCE_DISABLE_FIREBASE === 'true' || window.location.hostname.includes('china.');

if (shouldDisableFirebase) {
  // eslint-disable-next-line no-console
  console.warn('Firebase is disabled');
}

const firebaseApp = shouldDisableFirebase ? null : firebase.initializeApp(config);

let messagingInstance = null;
if (!shouldDisableFirebase && firebase.messaging.isSupported()) {
  messagingInstance = firebaseApp.messaging();
}

const messaging = messagingInstance;

// eslint-disable-next-line import/prefer-default-export
export { messaging, config, firebaseApp };
